// extracted by mini-css-extract-plugin
export default {"card":"user-card_card__TpnAh","profile":"user-card_profile__bbynf"};